import { ContentScope } from './contentScope';
import { requestJson } from './http';

const API_BASE_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:8000';

export interface HouseholdGift {
  id: string;
  household_id: string;
  story_id: string;
  title: string;
  content_scope?: ContentScope | null;
  gifted_by: string | null;
  status: string;
  creation_available: boolean;
  approved_render_id: string | null;
  preparation_render_id?: string | null;
}

/** Adult household scope is enforced by the server, never by a donor token. */
export async function fetchGifts(signal?: AbortSignal): Promise<HouseholdGift[]> {
  const token = localStorage.getItem('auth_token');
  const result = await requestJson<{ gifts: HouseholdGift[] }>(`${API_BASE_URL}/gifts`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    signal,
  });
  if (!result || !Array.isArray(result.gifts)) throw new Error('Gift status response is unavailable');
  return result.gifts;
}
